import React from 'react';
import PropTypes from 'prop-types';

const FormFieldMessage = ({ message }) => {
  if (message) {
    return <span className="help is-danger validation-error">{message}</span>;
  }

  return null;
};

FormFieldMessage.defaultProps = {
  message: '',
};

FormFieldMessage.propTypes = {
  message: PropTypes.string,
};

export default FormFieldMessage;



// WEBPACK FOOTER //
// ./src/components/FormFieldMessage.js